import { createMftpPlugin } from '@shg-mobile/mftp';

const environment =
  import.meta.env.DEV || import.meta.env.MODE === 'development'
    ? 'test'
    : import.meta.env.MODE === 'staging'
      ? 'staging'
      : '';

export const mftp = createMftpPlugin(environment);
